import axios from '../../../build/http-requests/axios-common'

export default {
  state: {

  },

  mutations: {
  },

  actions: {
    getCities: ({ commit }, uf) => {
      return new Promise((resolve, reject) => {
        axios.get('/cities/' + uf).then(response => {
          resolve(response.data.data)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/cities.js